import type { Clause, Position } from '@atlaskit/jql-ast';

const whiteSpaceRegex = /\s/;

/**
 * This function is responsible for getting the possible for a clause in a JQL.
 * (    project = "EM"    ) - this clause should include the surrounding whitespace and brackets
 */
export const getClausePosition = (jql: string, clause: Clause): Position | null => {
	if (!clause.position) {
		return null;
	}

	let [start, end]: [undefined | number, undefined | number] = [undefined, undefined];

	// Spreading the jql will account for multi-char unicode characters
	const jqlSymbols = [...jql];

	// Start
	for (let i = clause.position[0] - 1; i >= 0; i -= 1) {
		const symbol = jqlSymbols[i];

		if (symbol === '(') {
			start = i;
			break;
		}

		// The use of continue here to check for
		if (!whiteSpaceRegex.test(symbol)) {
			break;
		}
	}

	// short circuit here if no '(' is found
	if (start === undefined) {
		return clause.position;
	}

	// End
	for (let i = clause.position[1]; i <= jqlSymbols.length; i += 1) {
		const symbol = jqlSymbols[i];

		if (symbol === ')') {
			end = i + 1;
			break;
		}

		if (!whiteSpaceRegex.test(symbol)) {
			break;
		}
	}

	return start !== undefined && end !== undefined ? [start, end] : clause.position;
};
